import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/services/env.service';

export interface Graph_Search {
  _id?: string;
  reference: string;
  description: string;
  investigationType?: string;
  neovis_search?: any;
  created_at?: Date;
  updated_at?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class NeovisService {
  constructor(private http: HttpClient, private env: EnvService) {}

  create(graph_search: Graph_Search) {
    return this.http.post(`${this.env.URL_API_V1}/graph_search`, graph_search);
  }

  update(graph_search: any) {
    console.log('actualizo desde el update');

    return this.http.put(
      `${this.env.URL_API_V1}/graph_search/${graph_search._id}`,
      graph_search
    );
  }

  delete(_id: string) {
    return this.http.delete(`${this.env.URL_API_V1}/graph_search/${_id}`);
  }

  get() {
    return this.http.get<Graph_Search[]>(`${this.env.URL_API_V1}/graph_search`);
  }

  getById(_id: string) {
    return this.http.get<Graph_Search>(
      `${this.env.URL_API_V1}/graph_search/${_id}`
    );
  }
}
